import axios from 'axios'
const { VUE_APP_API_URL } = process.env

const fetchWidgetyItinInfo = async (ship_name, start_date, end_date) => {
  if (!end_date || !ship_name || !start_date) return null
  const specialCharacters = {
    "La D??sirade": "La Désirade", 
    "MS Vester??len": "MS Vesterålen",
    "Le Sol??al": "Le Soléal", 
    "Le Laperouse": "Le Lapérouse",
    "ms Lumi??re": "ms Lumière", 
    "S.S. S??o Gabriel": "S.S. São Gabriel", 
    "S.S. S??o Rafael": "S.S. São Rafael"}
    if (specialCharacters[ship_name]) {
      ship_name = specialCharacters[ship_name]
    }
  try {
    const res = await axios.post(
      `${VUE_APP_API_URL}/widgety-public/viewtrail/itin`,
      {
        starts_on: start_date,
        ends_on: end_date,
        ship_title: ship_name,
      }
    )
  
    if (res && res.data) {
      return res.data
    }
  } catch (err) {
    return null
  }
}

export { fetchWidgetyItinInfo }
